import { Injectable } from '@angular/core';
import {CrudService} from '../../services';
import {Order, OrderWithIdent, Referral} from '../../dto/order';
import {HttpClient, HttpParams, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
import {DataListModel} from '../../models/data-list-model';
import {toISODateString, toServerDateString} from '../../providers/app-date-adapter';
import {EnumModel} from '../../models/enum-model';
import {OrderCancellationModel} from '../../models/order-cancellation-model';
import {ResendWebidModel} from '../../models/resend-webid-model';
import {WebIdTransaction} from '../../dto/web-id-transaction';
import {OrderLightStatus} from '../../dto/order-light-status';
import {CardReorderModel} from '../../models/card-reorder-model';
import {DateTableFilter} from '../../table-datasouces/date-table-filter';
import {PrevNextModel} from '../../models/prev-next-model';
import {PrevNextIdModel} from '../../models/prev-next-id-model';
import {Card} from '../../dto/card';
import {BankTransferLoad} from '../../dto/bankTransferLoad';

@Injectable({
  providedIn: 'root'
})
export class ReferralsService  implements CrudService<Referral> {

  readonly apiPath = 'referrals/';

  constructor(private http: HttpClient) { }
  get(id: any) {
    return this.http.get(this.apiPath + id) as Observable<Referral>;
  }

  getMany(
    pageIndex: number,
    pageSize: number,
    sortField: string,
    sortDirection: string,
    filterString: string,
    dateFilterCols: string[],
    startFilterDate: Date,
    endFilterDate: Date,
    someAdditionalData: string,
    additionalFilterData?: string[],
    enumFilter?: { key: string; value: string},
    companiesFilter?: string[]

): Observable<DataListModel<Referral>> {
    let params = new HttpParams()
      .set('page', pageIndex.toString())
      .set('pageSize', pageSize.toString())
      .set('filterString', filterString)
      .set('sortField', sortField)
      .set('sortDirection', sortDirection)
      .set('startFilterDate', toServerDateString(startFilterDate))
      .set('endFilterDate', toServerDateString(endFilterDate))
      .set('someAdditionalData', someAdditionalData);

    if (companiesFilter instanceof Array) {
    companiesFilter.forEach(element => {
      params = params.append('companiesFilter', element);
    });
  }

  if (dateFilterCols instanceof Array) {
    dateFilterCols.forEach(element => {
      params = params.append('dateFilterCols', element);
    });
  }
  if (additionalFilterData instanceof Array) {
    additionalFilterData.forEach(element => {
      params = params.append('additionalFilterData', element);
    });
  }
  if (enumFilter) {
    params = params.append('enumFilter', JSON.stringify(enumFilter));
  }

  return this.http.get(this.apiPath, { params }) as Observable<DataListModel<Referral>>;

}
  add(item: Referral): Observable<Object> {
    throw new Error('Method not implemented.');
  }
  update(item: Order) {
    return this.http.put(this.apiPath, item) as Observable<Referral>;
  }

  getPendingCount(): Observable<number> {
    return this.http.get(this.apiPath + 'pending-count') as Observable<number>;
  }

  getOverallCount(): Observable<number> {
    return this.http.get(this.apiPath + 'overall-count') as Observable<number>;
  }


  deleteMany(idList: any[]) {
    let httpParams = new HttpParams();

    idList.forEach(id => {
      httpParams = httpParams.append('list', id.toString());
    });

    return this.http.delete(this.apiPath, { params: httpParams });
  }

  restoreMany(idList: any[]) {
    let httpParams = new HttpParams();
    idList.forEach(id => {
      httpParams = httpParams.append('list', id.toString());
    });
    return this.http.patch(this.apiPath, null, { params: httpParams });
  }

  delete(id: any) {
    return this.deleteMany([id]);
  }

  restore(id: any) {
    return this.restoreMany([id]);
  }


  payBonus(referralId: number) {
    return this.http.post(this.apiPath +'pay-bonus', {referralId}) as Observable<any>;

  }
}
